import * as React from 'react';
import { ERROR_CODES } from 'ts/passwordless-login/components/pages/error/ErrorCodes';
import { navigateToErrorPageFromForgotEmail } from 'ts/passwordless-login/components/pages/error/ErrorNavigation';
import { Content } from 'ts/passwordless-login/components/pages/find-email/Interfaces';
import { findAccountByCriteria } from 'ts/services/find-account/FindAccountService';
import { DOB, USERNAME, LAST_NAME, POSTCODE } from '../../../../constants/UrlParams';
import { ROUTES } from '../../../../Routes';
import { FindEmailPage } from '../../pages/find-email/FindEmailPage';
import { getForgotEmailUrl } from 'ts/config/ConfigService';

interface ForgotUsernameCustomerLookupPageProps {
  history: any;
}

const nextAction = (history: any) => (email: string) => {
  return history.push({
    pathname: ROUTES.FORGOT_USERNAME_ACCOUNT_FOUND,
    search: `?${USERNAME}=${email}`,
  });
};

const conflictAccountAction = (history: any) => (
  lastName: string,
  dob: string,
  postcode: string,
) => {
  return history.push({
    pathname: ROUTES.FORGOT_USERNAME_ACCOUNT_NUMBER,
    search: `?${LAST_NAME}=${lastName}&${DOB}=${dob}&${POSTCODE}=${postcode}`,
  });
};

const errorPageAction = (history: any) => () => {
  navigateToErrorPageFromForgotEmail(ERROR_CODES.FORGOT_EMAIL_3_POINT_CHECK, history);
};

const findAccountAction = (lastName: string, dob: string, postcode: string) => {
  return findAccountByCriteria(lastName, dob, postcode);
};

const ForgotUsernameCustomerLookupPage: React.FC<ForgotUsernameCustomerLookupPageProps> = ({
  history,
}) => {
  const content: Content = {
    analytics: {
      navigation: {
        friendlyUri: 'originenergy:my-account:auth:forgot-email-verify',
      },
      taskType: 'forgot-email',
      errorForm: {
        formName: 'my-account:forgot-email',
        errorMessage: 'forgot-email:account-not-found',
        errorCode: 'account-not-found',
      },
    },
    copy: {
      headingText: "Let's find your email",
      infoText: `Let's get some extra details to verify who you are. If you're a business customer, find your [email here](${getForgotEmailUrl()}).`,
      alertBoxText:
        "Hmm, we can't find an account linked to those details. Please check and try again, or [contact us](mailto:support@originenergy.com.au).",
    },
  };

  return (
    <FindEmailPage
      findAccountAction={findAccountAction}
      errorPageAction={errorPageAction(history)}
      content={content}
      history={history}
      nextAction={nextAction(history)}
      conflictAccountAction={conflictAccountAction(history)}
    />
  );
};

export { ForgotUsernameCustomerLookupPage };
